module.exports = "/_next/static/images/ccf0abe0f6af89e8cde106d56a5031d1-man-looking-up-smiling-lg@1x.jpg";